import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import { PrintReceivedPalletAndCaseLabels } from './printReceivedPalletAndCaseTags';

function PrintReceivedPalletAndCaseLabelsModal({ onClose, open, poMapGroupId, poMapId, type }) {
    return (
        <div>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
                <DialogTitle style={{ textAlign: 'center', paddingBottom: 0 }}>
                    Print Pallet And Case Labels
                </DialogTitle>
                <DialogContent style={{ margin: 0 }}>
                    <PrintReceivedPalletAndCaseLabels poMapGroupId={poMapGroupId} poMapId={poMapId} type={type} />
                </DialogContent>
            </Dialog>
        </div>
    );
}

export { PrintReceivedPalletAndCaseLabelsModal };
